export default __webpack_public_path__ + "static/media/cijevizolirana2.170dae41.jpg";